import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  getDroppedLead,
  updateLead,
  createLeadComment,
  getUsers,
  getLeadTimeline,
  restoreDroppedLeads,
} from "../api";
import { useAuth } from "../context/AuthContext";

                function fmtDate(d) {
                return d
                    ? new Date(d).toLocaleString("en-IN", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                    })
                    : "—";
                }

                export default function DropDetail() {

                const { id } = useParams();
                const navigate = useNavigate();
                const { user } = useAuth();

                const [lead, setLead] = useState(null);
                const [users, setUsers] = useState([]);
                const [timeline, setTimeline] = useState([]);

                const [loading, setLoading] = useState(true);
                const [saving, setSaving] = useState(false);

                const [toast, setToast] = useState("");

                const [newComment, setNewComment] = useState("");

                const showToast = (msg) => {
    setToast(msg);
    setTimeout(() => setToast(""), 3000);
  };

  const load = useCallback(async () => {
    try {

      const [leadRes, usersRes] =
await Promise.all([
    getDroppedLead(id),
    getUsers(),
]);

const timelineRes = await getLeadTimeline(id);

setLead(leadRes.data);
setUsers(usersRes.data);
setTimeline(timelineRes.data);

    } catch (err) {

      console.error(err);
      navigate("/drop");

    } finally {

      setLoading(false);

    }

  }, [id, navigate]);

  useEffect(() => {
    load();
  }, [load]);
    const update = async (field, value) => {
    try {
      setSaving(true);

      await updateLead(id, {
        [field]: value,
      });

      setLead((prev) => ({
        ...prev,
        [field]: value,
      }));

      showToast("Saved");

    } catch (err) {

      console.error(err);
      showToast("Save Failed");

    } finally {

      setSaving(false);

    }
  };

  const addTimelineComment = async () => {

    if (!newComment.trim()) return;

    try {

      await createLeadComment(id, {
        comment: newComment,
      });

      setNewComment("");

      await load();

    } catch (err) {

      console.error(err);

      showToast("Could not add comment");

    }

  };

const activateLead = async () => {

  try {

    await restoreDroppedLeads([lead.id]);

    showToast("Lead Activated Successfully");

    navigate("/drop");

  } catch (err) {

    console.error(err);

    alert("Could not activate lead");

  }

};

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
      </div>
    );
  }

  if (!lead) return null;
    return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>

      {toast && (
        <div className="toast-container">
          <div className="toast success">
            {toast}
          </div>
        </div>
      )}

      {/* Header */}

      <div className="page-header">

        <div>

          <button
            className="btn btn-ghost btn-sm"
            onClick={() => navigate(-1)}
            style={{ marginBottom: "4px" }}
          >
            ← Back
          </button>

          <div className="page-title">
            {lead.name}
          </div>

          <div className="page-subtitle">
            {lead.phone}
            {lead.source ? ` · ${lead.source}` : ""}
            {lead.campaign_name ? ` · ${lead.campaign_name}` : ""}
          </div>

        </div>

        <div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
  }}
>

  <button
    className="btn"
    onClick={activateLead}
    style={{
      background: "#7AC142",
      color: "#fff",
      border: "none",
      borderRadius: "999px",
      padding: "10px 24px",
      fontWeight: 600,
      cursor: "pointer",
    }}
  >
    Activate Lead
  </button>

  {saving && (

    <span
      style={{
        fontSize: 12,
        color: "#888",
      }}
    >
      Saving...
    </span>

  )}

</div>

      </div>

      <div
        style={{
          flex: 1,
          overflow: "auto",
          padding: "16px 20px",
        }}
      >

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 380px",
            gap: "16px",
            maxWidth: "1100px",
          }}
        >

          {/* LEFT COLUMN */}

          <div>
            {/* ================= ACTIVITY TIMELINE ================= */}

<div className="card">

  <div
    className="panel-section-title"
    style={{ marginBottom: "14px" }}
  >
    Activity Timeline
  </div>

  <div
    style={{
      display: "flex",
      gap: 10,
      marginBottom: 18,
    }}
  >
    <input
      type="text"
      placeholder="Write a comment..."
      value={newComment}
      onChange={(e) => setNewComment(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          addTimelineComment();
        }
      }}
      className="form-input"
      style={{ flex: 1 }}
    />

    <button
      className="btn"
      onClick={addTimelineComment}
    >
      Post
    </button>
  </div>

  {timeline.length === 0 ? (

    <div
      style={{
        color: "#999",
        fontSize: 13,
      }}
    >
      No activity yet
    </div>

  ) : (

    timeline.map((item, index) => (

      <div
        key={`${item.event_type}-${item.id}-${index}`}
        style={{
          padding: "12px 0",
          borderBottom:
            index !== timeline.length - 1
              ? "1px solid #eee"
              : "none",
        }}
      >

        <div
          style={{
            fontWeight: 600,
            fontSize: 15,
            color: "#222",
          }}
        >
          {item.description}
        </div>

        <div
          style={{
            marginTop: 5,
            color: "#888",
            fontSize: 12,
          }}
        >
          {item.user_name || "Unknown User"} ·{" "}
          {fmtDate(item.created_at)}
        </div>

      </div>

    ))

  )}

</div>

</div>

{/* RIGHT COLUMN */}

<div>
    {/* Assigned To */}

                <div className="card" style={{ marginBottom: "14px" }}>

                <div
                    className="panel-section-title"
                    style={{ marginBottom: "10px" }}
                >
                    Assigned To
                </div>

                <select
                    className="form-input"
                    value={lead.assigned_to || ""}
                    onChange={(e) => update("assigned_to", e.target.value)}
                >

                    {users
                    .filter((u) => u.role === "sales_manager")
                    .map((u) => (

                        <option
                        key={u.id}
                        value={u.id}
                        >
                        {u.name}
                        </option>

                    ))}

                </select>

                </div>
                {/* Drop Details */}

                <div className="card">

                <div
                    className="panel-section-title"
                    style={{ marginBottom: "10px" }}
                >
                    Drop Details
                </div>

                <div className="info-grid">

                    {[
                    {
                        label: "Phone",
                        value: lead.phone || "—",
                    },

                    {
                        label: "Email",
                        value: lead.email || "—",
                    },

                    {
                        label: "Source",
                        value: lead.source || "—",
                    },

                    {
                        label: "Campaign",
                        value: lead.campaign_name || "—",
                    },

                    {
                        label: "Budget",
                        value: lead.budget_cr
                        ? `₹${lead.budget_cr} Cr`
                        : "—",
                        green: true,
                    },

                    {
                        label: "Drop Reason",
                        value: lead.drop_reason || "—",
                    },

                    {
                        label: "Dropped By",
                        value: lead.dropped_by_name || "—",
                    },

                    {
                        label: "Dropped On",
                        value: fmtDate(lead.dropped_at),
                    },

                    {
                        label: "Lead Created",
                        value: fmtDate(lead.created_at),
                    },
                    ].map((item) => (

                    <div key={item.label}>

                        <div className="info-item-label">
                        {item.label}
                        </div>

                        <div
          style={{
            fontSize: "13px",
            color: item.green ? "#1D9E75" : "#444",
                            fontWeight: item.green ? 600 : 400,
                            marginTop: "3px",
                        }}
                        >
                        {item.value}
                        </div>

                    </div>

                    ))}

                </div>

                {lead.notes && (

                    <div
                    style={{
                        marginTop: "16px",
                        paddingTop: "12px",
                        borderTop: "1px solid #eee",
                    }}
                    >

            <div className="info-item-label">
                Notes
            </div>

            <div
                style={{
                marginTop: "5px",
                fontSize: "13px",
                lineHeight: "1.6",
                }}
            >
                {lead.notes}
            </div>

            </div>

            )}

            </div>
                </div>
            </div>
            </div>
         
</div>

);
}